import React from 'react';
import { fieldLabel, hasValue } from './mailWriting';

export default function MailFieldMenu({ fields, active, onChoose, onBrowse, style }) {
  return <div className="mail-field-menu" style={style} role="listbox" aria-label="Insert a field">
    <header>Insert a field <small>↑ ↓ to move · Enter to insert · Esc to close</small></header>
    {onBrowse && <button type="button" onMouseDown={e=>e.preventDefault()} onClick={onBrowse}>Browse connected apps →</button>}
    {!fields.length && <p>No matching fields. Choose a person or source to load their data.</p>}
    {fields.slice(0, 40).map(([key,value], index) => <button type="button" role="option" aria-selected={index === active} key={key} onMouseDown={e=>e.preventDefault()} onClick={()=>onChoose(key)}>
      <span><strong>{fieldLabel(key)}</strong><small>{key}</small></span><span className={hasValue(value)?'':'is-missing'}>{hasValue(value)?String(value):'Missing value'}</span>
    </button>)}
  </div>;
}
